import {vals} from '../../../util'
import Promise from 'bluebird'

// initial state
const state = {
    firstName   : '',
    lastName    : '',
    email       : '',
    password    : '',
    token       : '',
    serverId    : '',
    isNew       : true,
    currencyFormat  : 'US_DOLLAR'
}

// getters
// ref: getter sig = (state, getters, rootState)
const getters = {
    user        : state => {
        return { firstName:state.firstName, lastName:state.lastName, email:state.email, serverId:state.serverId }
    },
    hasToken    : state => {
        return state.token !== '' && state.token !== undefined
    },
    token       : state => {
        return state.token
    },
    isNew       : state => {
        return state.isNew
    },
    currency    : state => {
        return vals.CURRENCIES[state.currencyFormat]
    }
}

// mutations - (also thought as 'setters')
const mutations = {
    setLogin (state, payload) {
        state.email = payload.email
        state.password = payload.password
    },
    setToken (state, payload) {
        state.token = payload.token
    },
    setUser (state, payload) {
        state.firstName = payload.data.first_name,
        state.lastName  = payload.data.last_name,
        state.serverId  = payload.data.uuid
    },
    initialize (state) {
        state.email = ''
        state.password = ''
        state.firstName = ''
        state.lastName = ''
        state.token = ''
        state.serverId = ''
    },
    markNew (state, payload) {
        state.isNew = payload.newProfile
    }
}

// actions - controller-esque logic
const actions = {
    start ({}) {},
    stop ({}) {},
    cycle ({}) {},
    login ({commit}, user) { // unused for now
        return new Promise((resolve, reject) => {
        })
    },
    loginRefresh ({commit}) {
        // see if we still have a valid jwt token
        return new Promise((resolve, reject) => {
            reject({})
        })
    },
    authorizeLI ({commit}) {
        return new Promise((resolve, reject) => { // can't be done in the fake api (requires communication with linkedin)
        })
    },
    apiConfirmLI ({commit,state,getters}, code) { // for now not using this -- LinkedIn requires the redirect be the exact same as the request to get the code (stupid is as stupid does)
        return new Promise((resolve, reject) => {
            commit('setUser', {data: {first_name: 'test', last_name: 'testerson', uuid: 1}})
            commit('setToken', {token: 'this-is-gibberish'})
            resolve({})
        })
    },
    apiGetProfile ({state}, id) {
        return new Promise((resolve, reject) => {
            resolve(state.getters.user)
        })
    },
    apiDeleteUser ({commit}) {
        return new Promise((resolve, reject) => {
            commit('initialize')
            resolve({})
        })
    }
}

export default {
    namespaced : true,
    state,
    getters,
    mutations,
    actions
}